import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Card, Table, Statistic, Row, Col } from 'antd';

const { Title, Paragraph } = Typography;

const ROIReports = () => {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => {
      setRows([
        { name: 'Local Awareness', spend: 1500, revenue: 7200, roas: '4.8x', roi: '380%' },
        { name: 'Back-to-School', spend: 3000, revenue: 12800, roas: '4.27x', roi: '327%' },
      ]);
      setLoading(false);
    }, 250);
    return () => clearTimeout(t);
  }, []);

  const columns = [
    { title: 'Campaign', dataIndex: 'name', key: 'name' },
    { title: 'Spend', dataIndex: 'spend', key: 'spend', render: v => `$${v.toLocaleString?.() || v}` },
    { title: 'Revenue', dataIndex: 'revenue', key: 'revenue', render: v => `$${v.toLocaleString?.() || v}` },
    { title: 'ROAS', dataIndex: 'roas', key: 'roas' },
    { title: 'ROI', dataIndex: 'roi', key: 'roi' },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[{ title: 'Client' }, { title: 'Analytics' }, { title: 'ROI Reports' }]} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>ROI Reports</Title>
      </div>

      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col xs={24} md={8}><Card><Statistic title="Total Spend" value={4500} prefix="$" /></Card></Col>
        <Col xs={24} md={8}><Card><Statistic title="Total Revenue" value={20000} prefix="$" /></Card></Col>
        <Col xs={24} md={8}><Card><Statistic title="Avg. ROAS" value="4.44x" /></Card></Col>
      </Row>

      <Card>
        <Paragraph type="secondary" style={{ marginBottom: 12 }}>Return on investment by campaign.</Paragraph>
        <Table rowKey="name" columns={columns} dataSource={rows} loading={loading} pagination={{ pageSize: 10 }} />
      </Card>
    </div>
  );
};

export default ROIReports;
